import React from "react";
import ReactDOM from "react-dom";
// import Handlebars from "handlebars";
const { data } = require('./Footer.data');

import "./Footer.scss";

// const htmlContent = require("./Footer.html");
import htmlContent from './Footer.hbs';// works as template fn

// const template = Handlebars.compile(htmlContent);// fails

const Footer = (props) => {

  const {
    // data
  } = props;

  const h_cont = htmlContent(data);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: h_cont }} className={`hbs_comp plax-bg`} />
      {/* <div dangerouslySetInnerHTML={{ __html: template(data) }} /> */}
    </>
  );
}

export default Footer
